
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/xususiy-universitetlar/[universityId]/[directionName]",
      function () {
        return require("private-next-pages/xususiy-universitetlar/[universityId]/[directionName]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/xususiy-universitetlar/[universityId]/[directionName]"])
      });
    }
  